import { createSelector } from "reselect"
import { map, includes, pick } from "lodash"
import { getSelectedMetric } from "./metrics"

const getPositionSets = (state, props) => props.positionSets

export const getItems = createSelector(
  [getPositionSets, getSelectedMetric],
  (positionSets, selectedMetric) => map(positionSets,
    (ps, index) => ({
      id: String(index),
      disabled: ps.isUnmodeled || (!includes(["portfolio", "experiment", "inline"], ps.type) && selectedMetric.id === "gmv") || (!includes(["portfolio", "experiment"], ps.type) && selectedMetric.id === "equity"),
      ...pick(ps, ["color", "label", "noData", "isUnmodeled"]),
      type: ps.baseType || ps.type, // ResearchTopic item's types are all inline so we need the baseType
    })),
)
